import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ButtonOutline } from '../GeneralComponents/ButtonOutline/ButtonOutline'
import { REQUEST_STATE } from './useIngestRequest'
import classes from './confirm.module.css'

/**
 * Confirmation for a content refresh, shaped after FeelsSync's (the house
 * pattern for "this starts a long job").
 */
export default function RefreshArtistConfirm({ artistName, state, onConfirm, onCancel }) {
  const busy = state === REQUEST_STATE.SENDING

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <h3 className={classes.title}>Sync {artistName || 'this artist'}?</h3>

        <div className={classes.message}>
          <p>
            This fetches {artistName || 'this artist'} again from YouTube — releases and songs. If a
            synchronization for them is already running, this opens that one instead.
          </p>
          <p>
            It will appear on the{' '}
            <Link to="/ingest" className={classes.link}>
              Ingest Status
            </Link>{' '}
            page as a request from you, where you can follow how far it gets.
          </p>
          <p>
            If the matcher cannot decide something on its own, this comes back to you for a decision.
          </p>

        </div>
      </div>

      <div className={classes.actions}>
        <ButtonOutline
          text={busy ? 'STARTING…' : 'REQUEST SYNC'}
          color="green"
          size="small"
          disable={busy}
          onClick={onConfirm}
          className={classes.confirmButton}
        />
        <ButtonOutline
          text="CANCEL"
          color="pink"
          size="small"
          onClick={onCancel}
          className={classes.cancelButton}
        />
      </div>
    </div>
  )
}

RefreshArtistConfirm.propTypes = {
  artistName: PropTypes.string,
  state: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
